import React from "react";
import MeasuredShape from "./components/MeasuredShape";
import { defaultStateFor } from "./defaults";

// Vector shapes from the Bileşenler → Şekiller panel. The box state holds the
// catalog id plus fill / stroke / radius / shadow / text; everything is edited
// in the Şekil ayarları dialog (_editor/components/shape_settings), so the
// toolbar has no accordions of its own.
export function VectorShape(base) {
  return {
    getConfig() {
      return {
        name: "VectorShape",
        displayName: IdealStudio.i18n.t("VectorShape.PluginName") || "Shape",
        category: "objects",
        needsConfigModal: false,
        needsTextEdition: false,
        flavor: "react",
        initialWidth: "20%",
        initialHeight: "20%",
        initialWidthSlide: "20%",
        initialHeightSlide: "20%",
        icon: "category",
        allowFloatingBox: true,
      };
    },
    getToolbar() {
      return {
        main: {
          __name: "Main",
          accordions: {},
        },
      };
    },
    getInitialState() {
      return defaultStateFor("rect");
    },
    getRenderTemplate(state) {
      return <MeasuredShape state={state} />;
    },
  };
}
